<div class="checkbox-wrapper label-is-right {{classess}}" [class.disabled]="disabled"
  [class.label-is-right]="labelPosition === 'After'" [class.label-is-left]="labelPosition === 'Before'">

  <p-checkbox (onChange)="checkboxChanged($event)" [value]="value" [formControl]="control" [name]="name"
    [binary]="binary" [inputId]="name"></p-checkbox>
  <label [id]="name" [for]="name">{{label}} @if(count || count === 0){<span class="count">({{count}})</span>} </label>
</div>
